function setUid(id: string | number) {
  const { gtag } = useGtag()
  const runtimeConfig = useRuntimeConfig()
  gtag('config', runtimeConfig.public.gtagId, {
    user_id: id ? String(id) : ''
  })
}
/**
 * @param { string} eventId 事件ID
 * @param {[key: string]: number | string} params 传参
 */
function eventLog(
  eventId: string,
  params?: {
    [key: string]: number | string | { item_id: string; item_name: string }[]
  }
) {
  // iOS房间不再做埋点
  if (usePublicStore().isIOSWebView) return
  console.log(eventId, params)
  const { gtag } = useGtag()

  // 官方事件只设置对应的SDK，自定义则都设置
  if (eventIdGtag[eventId]) {
    gtag('event', eventId, params)
  } else if (eventIdFB[eventId]) {
    // window['fbq']('track', eventId, params)
  } else {
    gtag('event', eventId, params)
  }
}

// gatg标准事件ID，官方事件，key和value值要一致
const eventIdGtag: { [key: string]: string } = {
  purchase: 'purchase' //购买事件
}

// FB标准事件ID，官方事件，key和value值要一致
const eventIdFB: { [key: string]: string } = {
  Purchase: 'Purchase', // 购买事件
  AddPaymentInfo: 'AddPaymentInfo', // 添加支付信息
  CompleteRegistration: 'CompleteRegistration' // 登录
}

// 埋点事件ID  自定义事件
const eventId = {
  //#region 网页端原有的埋点
  // 匹配
  // video_start_match: 'h5_video_start_match', // 开始匹配
  // exit_by_match_another: 'h5_exit_by_match_another', //匹配下一个
  // 拨打
  // home_popular_video_call_click: 'h5_home_popular_video_call_click', // 首页popular呼叫按钮点击
  // chat_video_call_click: 'h5_chat_video_call_click', // 私聊点击拨打
  // click_user_info_video_call: 'h5_click_user_info_video_call', // 点击主播详情页通话
  // click_room_video_call: 'h5_click_room_video_call', // 点击直播内通话
  // click_recharge_resume_call: 'h5_click_recharge_resume_call', // 点击充值回调后恢复之前通话
  // 房间 直播房-视频通话房-匹配视频通话房
  // enter_private_room: 'h5_enter_private_room', // 进入1v1通话房间
  enter_room: 'h5_enter_room', // 进入直播间
  // enter_match_room: 'h5_enter_match_room', // 进入匹配通话房间
  // 登录
  login_way_google: 'h5_login_way_google', //登陆成功-谷歌
  login_way_apple: 'h5_login_way_apple', //登陆成功-苹果
  // login_historical_user_google: 'h5_login_historical_user_google', // 登录成功-谷歌-老用户
  // login_historical_user_apple: 'h5_login_historical_user_apple', // 登录成功-苹果-老用户
  // new_user_registration_google: 'h5_new_user_registration_google', // 登录成功-谷歌-新用户
  // new_user_registration_apple: 'h5_new_user_registration_apple', // 登录成功-苹果-新用户
  // 充值
  create_a_recharge_order: 'h5_create_a_recharge_order', // 创建充值订单
  open_charge_page: 'h5_open_charge_page', // 打开充值页面
  payment_result: 'h5_payment_result', // 创建充值订单_回调落地
  payment_result_success: 'h5_payment_result_success', // 创建充值订单_成功
  payment_result_fail: 'h5_payment_result_fail', // 创建充值订单_失败
  payment_result_abnormal: 'h5_payment_result_abnormal', // 创建充值订单_异常
  payment_result_waiting: 'h5_payment_result_waiting', // 创建充值订单_等待中
  // 消息
  call_after_message: 'h5_call_after_message', // 有效电话通话后，主播给用户回复信息
  // 引流至App
  // go_to_appstore: 'h5_go_to_appstore', // 跳转苹果应用商店，登录弹窗
  // go_to_google_play: 'h5_go_to_google_play', // 跳转谷歌应用商店，登录弹窗
  // msg_go_to_appstore: 'h5_msg_go_to_appstore', // 跳转苹果应用商店,免费文字聊天结束后,每20条付费文字
  // msg_go_to_google_play: 'h5_msg_go_to_google_play', // 跳转谷歌应用商店,免费文字聊天结束后,每20条付费文字
  // msg_go_to_download_popup: 'h5_msg_go_to_download_popup', // 跳转谷歌应用商店,免费文字聊天结束后,每20条付费文字：引流至App弹窗 显示次数
  // call_go_to_appstore: 'h5_call_go_to_appstore', // 跳转苹果应用商店,在网页端首次完成一通通话,在网页端每完成10通通话
  // call_go_to_google_play: 'h5_call_go_to_google_play', // 跳转谷歌应用商店,在网页端首次完成一通通话,在网页端每完成10通通话
  // call_go_to_download_popup: 'h5_call_go_to_download_popup', // 跳转谷歌应用商店,在网页端首次完成一通通话,在网页端每完成10通通话：引流至App弹窗 显示次数
  // live_go_to_appstore: 'h5_live_go_to_appstore', // 跳转苹果应用商店,直播列表
  // live_go_to_google_play: 'h5_live_go_to_google_play', // 跳转谷歌应用商店,直播列表
  // live_go_to_download_popup: 'h5_live_go_to_download_popup', // 跳转谷歌应用商店,直播列表：引流至App弹窗 显示次数
  // recharge_go_to_appstore: 'h5_recharge_go_to_appstore', // 跳转苹果应用商店,充值支付成功
  // recharge_go_to_google_play: 'h5_recharge_go_to_google_play', // 跳转谷歌应用商店,充值支付成功
  recharge_go_to_download_popup: 'h5_recharge_go_to_download_popup', // 跳转谷歌应用商店,直播列表：引流至App弹窗 显示次数
  // 其他
  open_user_info_page: 'h5_open_user_info_page', // 打开主播详情
  //#endregion

  //#region 同步客户端埋点
  // 外部H5页面、游戏
  open: 'h5_open', // 打开H5页面
  open_game_collection: 'h5_open_game_collection', // 打开游戏面板
  open_game_777: 'h5_open_game_777', // 打开777游戏
  open_game_ferris_wheel: 'h5_open_game_ferris_wheel', // 打开ferris_wheel游戏
  open_game_fruit_loops: 'h5_open_game_fruit_loops', // 打开fruit_loops游戏
  open_game_greedy_king: 'h5_open_game_greedy_king', // 打开greedy_king游戏
  open_game_lineslots: 'h5_open_game_lineslots', // 打开lineslots游戏
  open_game_roullete: 'h5_open_game_roullete', // 打开roullete游戏
  open_game_teen_patti: 'h5_open_game_teen_patti', // 打开teen_patti游戏
  betting_game_777: 'h5_betting_game_777', // 对777游戏下注
  betting_game_ferris_wheel: 'h5_betting_game_ferris_wheel', // 对ferris_wheel游戏下注
  betting_game_fruit_loops: 'h5_betting_game_fruit_loops', // 对fruit_loops游戏下注
  betting_game_greedy_king: 'h5_betting_game_greedy_king', // 对greedy_king游戏下注
  betting_game_lineslots: 'h5_betting_game_lineslots', // 对lineslots游戏下注
  betting_game_roullete: 'h5_betting_game_roullete', // 对roullete游戏下注
  betting_game_teen_patti: 'h5_betting_game_teen_patti', // 对teen_patti游戏下注
  // 打开页面
  call_click_chat: 'h5_call_click_chat', // 打开chat页面
  call_click_country: 'h5_call_click_country', // 打开country页面
  call_click_follow: 'h5_call_click_follow' // 打开follow页面
  //#endregion
} as const

// 埋点跳转页面
function eventLogToPage(config: {
  path: '/recharge' | '/chatPage'
  query?: { [key: string]: string | number }
  replace?: boolean
}) {
  const router = useRouter()
  const paths = {
    '/recharge': eventId.open_charge_page,
    '/chatPage': eventId.call_click_chat
  }
  eventLog(paths[config.path])
  router.push({
    path: config.path,
    query: config.query || {},
    replace: config.replace || false
  })
}

export default {
  eventLog, //埋点
  eventId, // 埋点ID
  setUid,
  eventLogToPage,
  eventIdGtag,
  eventIdFB
}
